
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy, Do, Caution } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  Navigation lists support the information architecture providing users with a
  quick way to access the information they are looking for.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <p>{`The navigation list concept relies on an understanding that all "page" content type examples have the possibility of being both a parent and a child page.`}</p>
    <p>{`The navigation list defines the children that will be shown on the parent page (current page).`}</p>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/NavigationLists/Anatomy_img_desktop.png" srcset="https://inno-ecl.s3.amazonaws.com/media/images/EC/NavigationLists/Anatomy_img_mobile.png 892w, https://inno-ecl.s3.amazonaws.com/media/images/EC/NavigationLists/Anatomy_img_desktop.png 1468w" alt="Anatomy of navigation lists" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This section defines the children that will be shown.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Summary`}<sup>{`1`}</sup></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This section allows for a short description. It can be used when the child page has another page as its main parent or the links on the title section (grandchildren) are too long.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Links`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Use this section to show the content inside of the child page and allow a direct link to the subpages (grandchildren).`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Notes:`}</p>
    <ul>
      <li parentName="ul"><sup>1</sup> When a child has no children (primary links) the description from that child page will be shown underneath the title of the block. A summary should always be used in the absence of links</li>
    </ul>
    <h2>{`Do's and don'ts`}</h2>
    <Do title="Do" image="https://inno-ecl.s3.amazonaws.com/media/images/EC/NavigationLists/navigation-lists-do-desktop.jpg" alt="" description="Even if there are different types of lists on the same page it’s important to maintain a visual balance between." mdxType="Do" />
    <Caution title="Caution" image="https://inno-ecl.s3.amazonaws.com/media/images/EC/NavigationLists/navigation-lists-caution-desktop.jpg" alt="" description="Carefully consider how the lists are arranged on the page and how they behave responsively. Their positioning should support the scannability of the content." mdxType="Caution" />
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`use this component when you want to display content that it's part of the site's architecture`}</li>
      <li parentName="ul">{`use this component when you want to drill down into the architecture`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`don't use this component when you want to display temporary information that it's not part of the site's architecture`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;